<template>
  <div class="login">
    <div :style="{ marginRight: topWidth }"><topbar></topbar></div>
    <!--<div class="conHei"></div>-->
    <div v-if="process === 0" class="con">
      <div id="form">
        <div class="list">
          <img src="./img/user.png">
          <input type="text" v-model="postData.name" placeholder="姓名">
          <div class="error">{{errorMsgName}}</div>
        </div>
        <div class="list">
          <img src="./img/company.png">
          <input type="text" v-model="postData.companyName" placeholder="企业名称">
          <div class="error">{{errorMsgCompanyName}}</div>
        </div>
        <div class="list">
          <img src="./img/phone.png">
          <input type="text" v-model="postData.phoneNum" placeholder="手机">
          <div class="error">{{errorMsgPhone}}</div>
        </div>
        <div class="list">
          <img src="./img/mail.png">
          <input type="text" v-model="postData.email" placeholder="邮箱">
          <div class="error">{{errorMsgEmail}}</div>
        </div>
        <div class="listBotWrap"></div>
        <div class="but flexCenter" @click="apply()">申请试用</div>
      </div>
    </div>
    <div v-else class="con">
      <img id="okImg" src="./img/ok.png">
      <div id="okTitle" class="flexCenter">您的资料已成功提交,我们将尽快与您联系!</div>
      <div id="okText">访问<router-link to="/home">网站首页</router-link></div>
    </div>
    <div class="footer" :class="{footerFixed: footerCss}">© 2018 上海航数智能科技有限公司  沪ICP备16041202号-1 </div>
  </div>
</template>

<script>
import Topbar from '@/components/base/Topbar/index'
import Botcon from '@/components/base/Botcon/index'
export default {
  name: 'Login',
  components: {
    Topbar,
    Botcon
  },
  data () {
    return {
      postData: {
        name: '',
        companyName: '',
        phoneNum: '',
        email: ''
      },
      errorMsgName: '',
      errorMsgCompanyName: '',
      errorMsgPhone: '',
      errorMsgEmail: '',
      process: 0
    }
  },
  computed: {
    footerCss () {
      let r
      if (window.innerHeight > 688) {
        r = true
      } else {
        r = false
      }
      return r
    },
    topWidth () {
      let r
      if (this.$store.state.scroll === 0) {
        r = 0
      } else {
        r = this.$store.state.scroll + 'px'
      }
      return r
    }
  },
  created () {
    console.log('created')
  },
  methods: {
    apply () {
      let nameReg = /^[A-Za-z\u4E00-\u9FA5]{1,16}$/
      let phoneReg = /^1\d{10}$/
      let mailReg = /^[A-Za-z0-9_.-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
      if (!nameReg.test(this.postData.name)) {
        this.errorMsgName = this.postData.name === '' ? '请输入姓名' : '姓名格式错误'
        this.errorMsgCompanyName = ''
        this.errorMsgPhone = ''
        this.errorMsgEmail = ''
      } else if (this.postData.companyName === '') {
        console.log(this.postData.companyName)
        this.errorMsgName = ''
        this.errorMsgCompanyName = '请输入企业名称'
        this.errorMsgPhone = ''
        this.errorMsgEmail = ''
      } else if (!phoneReg.test(this.postData.phoneNum)) {
        this.errorMsgName = ''
        this.errorMsgCompanyName = ''
        this.errorMsgPhone = this.postData.phoneNum === '' ? '请输入手机号码' : '手机号码格式错误'
        this.errorMsgEmail = ''
      } else if (!mailReg.test(this.postData.email)) {
        this.errorMsgName = ''
        this.errorMsgCompanyName = ''
        this.errorMsgPhone = ''
        this.errorMsgEmail = this.postData.email === '' ? '请输入邮箱' : '邮箱格式错误'
      } else {
        this.errorMsgName = ''
        this.errorMsgCompanyName = ''
        this.errorMsgPhone = ''
        this.errorMsgEmail = ''
        this.axios.post('https://api-idc.hang-shu.com/v1/apply/message', this.postData).then(res => {
          this.process = res.data.result === 'success' ? 1 : 0
        }).catch(error => {
          console.log(error)
        })
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.login{ width: 100%; overflow-y: auto;}
.conhei{ width: 100%; height: 112px; position: relative;}
.flexCenter{display: flex; justify-content: center; align-items: center;}
.con{ width: 100%; height: 576px;  background: url('./img/bg.jpg') no-repeat center top;}
#form{ width: 510px; height: 406px; margin: 0 auto; padding-top: 85px;}
.list{ width: 510px; height: 56px; margin-bottom: 24px; background: rgba(255, 255, 255, 0.2);
border-radius: 4px; border: rgba(255, 255, 255, 0.7); display: flex; position: relative;}
.list:last-child{ margin-bottom: 7px;}
.listBotWrap{ width: 510px; height: 47px;}
.error{ width: 200px; height: 54px; font-size: 18px; color: #ff0000; position: absolute; top: 0; left: 520px;
 text-align: left; line-height: 54px;}

.list img{ display: block; width: 35px; height: 30px; margin: 12px 20px 0 13px;}
.list input{ display: block; flex: 1;outline: none;height: 54px;border: none;background: none;
font-size: 20px; line-height: 54px; color: #fff;}
input::-webkit-input-placeholder{ color: #fff;}
input:-moz-placeholder{ color: #fff;}
input::-moz-placeholder{ color: #fff;}
input:-ms-input-placeholder{ color: #fff;}

.but{ width: 510px; height: 56px; border-radius: 4px; background: #01b551; font-size: 20px;
 color: #fff; line-height: 22px;}

.footer{ width: 100%; height: 50px; text-align: center; font-size: 16px; color: #11223a; line-height: 50px;}
 .footerFixed{position: absolute; left: 0; bottom: 0;}

#okImg{ width: 103px; height: 104px; margin: 154px auto 0;}
#okTitle{ width: 100%; font-size: 28px; line-height: 32px; height: 100px; color: #fff;}
#okText{ widows: 100%; font-size: 22px; line-height: 32px; text-align: center; color: #fff;}
#okText a{ color: #fff; text-decoration: underline;}
</style>



// WEBPACK FOOTER //
// src/components/Login/index.vue